/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { NegozioDTO } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelPraticaEsercenteDetailDTO } from '../model/models';
import { PagedModelPraticaEsercenteEventoDTO } from '../model/models';
import { PagedModelPraticaEsercenteNotaDTO } from '../model/models';
import { PagedModelPraticaEsercenteSummaryDTO } from '../model/models';
import { PraticaEsercenteBackofficeListFilter } from '../model/models';
import { PraticaEsercenteCountersDTO } from '../model/models';
import { PraticaEsercenteDetailDTO } from '../model/models';
import { PraticaEsercenteEventoListFilter } from '../model/models';
import { PraticaEsercenteExportZipFilter } from '../model/models';
import { PraticaEsercenteNegozioAggiungiForm } from '../model/models';
import { PraticaEsercenteNotaCreateRequest } from '../model/models';
import { PraticaEsercenteNotaDTO } from '../model/models';
import { PraticaEsercentePdfRigeneraDTO } from '../model/models';
import { PraticaEsercenteStatoPatchForm } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface AggiungiNegozioPraticaEsercenteBackofficeRequestParams {
    idTipoPratica: string;
    idPratica: string;
    praticaEsercenteNegozioAggiungiForm: PraticaEsercenteNegozioAggiungiForm;
}

export interface CambioStatoPraticaEsercenteBackofficeRequestParams {
    idTipoPratica: string;
    idPratica: string;
    stato: PraticaEsercenteStatoPatchForm;
    convenzioneDaFirmare?: Blob;
    convenzione?: Blob;
}

export interface CancellaNotaPraticaEsercenteRequestParams {
    idTipoPratica: string;
    idPratica: string;
    idNota: string;
}

export interface CountPraticheEsercenteBackofficeRequestParams {
    idTipoPratica: string;
}

export interface CreaNotaPraticaEsercenteRequestParams {
    idTipoPratica: string;
    idPratica: string;
    praticaEsercenteNotaCreateRequest: PraticaEsercenteNotaCreateRequest;
}

export interface DownloadAllegatoPraticaEsercenteBackofficeRequestParams {
    idTipoPratica: string;
    idPratica: string;
    idAllegato: string;
}

export interface DownloadConvenzioneBandoEsercenteBackofficeRequestParams {
    idTipoPratica: string;
    idPratica: string;
}

export interface DownloadConvenzioneControfirmataEsercenteBackofficeRequestParams {
    idTipoPratica: string;
    idPratica: string;
}

export interface DownloadConvenzioneDaFirmareEsercenteBackofficeRequestParams {
    idTipoPratica: string;
    idPratica: string;
}

export interface DownloadConvenzioneFirmataEsercenteBackofficeRequestParams {
    idTipoPratica: string;
    idPratica: string;
}

export interface DownloadPdfOriginalePraticaEsercenteBackofficeRequestParams {
    idTipoPratica: string;
    idPratica: string;
}

export interface ExportTabularPraticheEsercenteBackofficeRequestParams {
    idTipoPratica: string;
    filter: PraticaEsercenteBackofficeListFilter;
    pageable: Pageable;
}

export interface ExportZipPraticheEsercenteBackofficeRequestParams {
    idTipoPratica: string;
    filter: PraticaEsercenteExportZipFilter;
}

export interface GetPraticaEsercenteBackofficeRequestParams {
    idTipoPratica: string;
    idPratica: string;
}

export interface ListEventiPraticaEsercenteBackofficeRequestParams {
    idTipoPratica: string;
    idPratica: string;
    filter: PraticaEsercenteEventoListFilter;
    pageable: Pageable;
}

export interface ListNegoziDisponibiliPraticaEsercenteBackofficeRequestParams {
    idTipoPratica: string;
    idPratica: string;
}

export interface ListNotePraticaEsercenteRequestParams {
    idTipoPratica: string;
    idPratica: string;
    pageable: Pageable;
}

export interface ListPraticheEsercenteBackofficeRequestParams {
    idTipoPratica: string;
    filter: PraticaEsercenteBackofficeListFilter;
    pageable: Pageable;
}

export interface RigeneraPdfPraticaEsercenteBackofficeRequestParams {
    idTipoPratica: string;
    idPratica: string;
    version: number;
}

export interface SostituisciConvenzioneDaFirmareEsercenteBackofficeRequestParams {
    idTipoPratica: string;
    idPratica: string;
    version: number;
    convenzioneDaFirmare: Blob;
}


export interface GestioneDomandeEsercenteServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Aggiunge un punto vendita a una domanda esercente gia\&#39; presentata.
     * Body {negozio_id, version}. Anche su domanda ABILITATA: il negozio nasce abilitato se la domanda lo e\&#39; (operativo al POS subito). Il PDF della domanda si rigenera dopo il commit (best-effort). Response: dettaglio backoffice aggiornato (con la version nuova). checkTipoPratica GESTIONE; 404 cross-bando o negozio non del titolare; 409 version stale o negozio gia\&#39; presente; 422 domanda terminale (ritirata/rifiutata) o esercente bloccato dall\&#39;amministrazione (esercente_bloccato; puo_aggiungere_negozio e\&#39; allora false).
     * @endpoint post /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/pratiche-esercente/{id_pratica}/negozi
* @param requestParameters
     */
    aggiungiNegozioPraticaEsercenteBackoffice(requestParameters: AggiungiNegozioPraticaEsercenteBackofficeRequestParams, extraHttpRequestParams?: any): Observable<PraticaEsercenteDetailDTO>;

    /**
     * Transizione di stato di una domanda esercente.
     * Multipart: part \&#39;stato\&#39; (JSON {nuovo_stato, version, nota?, modalita_convenzione?}) + eventuali part \&#39;convenzione_da_firmare\&#39; (PDF per la modalita\&#39; DOMANDA) e \&#39;convenzione\&#39; (controfirma facoltativa per → ABILITATA). Le azioni valide (stato, modalita\&#39;, documento, nota obbligatoria) sono in azioni_operatore del dettaglio. checkTipoPratica GESTIONE; passa dal chokepoint state-machine. 409 version stale; 422 transizione/modalita\&#39;/PDF/nota.
     * @endpoint patch /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/pratiche-esercente/{id_pratica}/stato
* @param requestParameters
     */
    cambioStatoPraticaEsercenteBackoffice(requestParameters: CambioStatoPraticaEsercenteBackofficeRequestParams, extraHttpRequestParams?: any): Observable<PraticaEsercenteDetailDTO>;

    /**
     * Cancella LOGICAMENTE una nota di lavorazione della domanda esercente (D-109).
     * Capability GESTIONE. Non e\&#39; una DELETE fisica: setta cancellataAt/cancellataDaUser ed emette NOTA_CANCELLATA in timeline. 422 se la nota e\&#39; gia\&#39; stata cancellata; 404 cross-tenant.
     * @endpoint delete /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/pratiche-esercente/{id_pratica}/note/{id_nota}
* @param requestParameters
     */
    cancellaNotaPraticaEsercente(requestParameters: CancellaNotaPraticaEsercenteRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Contatori delle domande esercente per stato (bando-scoped).
     * Conteggi zero-fillati per RichiestaPraticaEsercenteStatus + total. checkTipoPratica CONSULTAZIONE → 403 fuori scope. Dichiarato PRIMA del detail /{id_pratica} così \&#39;counters\&#39; non è catturato come id.
     * @endpoint get /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/pratiche-esercente/counters
* @param requestParameters
     */
    countPraticheEsercenteBackoffice(requestParameters: CountPraticheEsercenteBackofficeRequestParams, extraHttpRequestParams?: any): Observable<PraticaEsercenteCountersDTO>;

    /**
     * Aggiungi una nota di lavorazione alla domanda esercente.
     * Capability GESTIONE. Emette un evento NOTA_AGGIUNTA in timeline. 422 testo vuoto/troppo lungo; 404 cross-tenant; 403 fuori comune.
     * @endpoint post /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/pratiche-esercente/{id_pratica}/note
* @param requestParameters
     */
    creaNotaPraticaEsercente(requestParameters: CreaNotaPraticaEsercenteRequestParams, extraHttpRequestParams?: any): Observable<PraticaEsercenteNotaDTO>;

    /**
     * Scarica un allegato della domanda caricato dall\&#39;esercente (operatore).
     * Solo allegati origine&#x3D;ESERCENTE: del modulo o convenzione firmata (gli altri documenti hanno endpoint dedicati per tipo). checkTipoPratica CONSULTAZIONE + anti-IDOR a 2 hop (loadScoped + filtro origine). 404 privacy-preserving se allegato non della domanda, non dell\&#39;esercente, o domanda cross-bando.
     * @endpoint get /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/pratiche-esercente/{id_pratica}/allegati/{id_allegato}/download
* @param requestParameters
     */
    downloadAllegatoPraticaEsercenteBackoffice(requestParameters: DownloadAllegatoPraticaEsercenteBackofficeRequestParams, extraHttpRequestParams?: any): Observable<string>;

    /**
     * Scarica il file della convenzione del bando per la domanda (operatore).
     * In qualunque stato e modalita\&#39; della domanda (l\&#39;operatore la consulta prima di scegliere BANDO). Se la convenzione del bando e\&#39; un link, il link e\&#39; in convenzione_bando_link del dettaglio. checkTipoPratica CONSULTAZIONE; anti-IDOR come i gemelli. 404 se il bando non ha un file / cross-tenant.
     * @endpoint get /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/pratiche-esercente/{id_pratica}/convenzione-bando/download
* @param requestParameters
     */
    downloadConvenzioneBandoEsercenteBackoffice(requestParameters: DownloadConvenzioneBandoEsercenteBackofficeRequestParams, extraHttpRequestParams?: any): Observable<string>;

    /**
     * Scarica la convenzione controfirmata (operatore).
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/pratiche-esercente/{id_pratica}/convenzione-controfirmata/download
* @param requestParameters
     */
    downloadConvenzioneControfirmataEsercenteBackoffice(requestParameters: DownloadConvenzioneControfirmataEsercenteBackofficeRequestParams, extraHttpRequestParams?: any): Observable<string>;

    /**
     * Scarica il documento da firmare caricato per la domanda (operatore).
     * Modalita\&#39; DOMANDA. checkTipoPratica CONSULTAZIONE; anti-IDOR come i gemelli (domanda caricata nel bando dell\&#39;URL). 404 se assente / cross-tenant.
     * @endpoint get /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/pratiche-esercente/{id_pratica}/convenzione-da-firmare/download
* @param requestParameters
     */
    downloadConvenzioneDaFirmareEsercenteBackoffice(requestParameters: DownloadConvenzioneDaFirmareEsercenteBackofficeRequestParams, extraHttpRequestParams?: any): Observable<string>;

    /**
     * Scarica la convenzione firmata (operatore).
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/pratiche-esercente/{id_pratica}/convenzione-firmata/download
* @param requestParameters
     */
    downloadConvenzioneFirmataEsercenteBackoffice(requestParameters: DownloadConvenzioneFirmataEsercenteBackofficeRequestParams, extraHttpRequestParams?: any): Observable<string>;

    /**
     * Scarica il PDF della domanda (operatore).
     * PDF generato al submit (o rigenerato). checkTipoPratica CONSULTAZIONE; anti-IDOR come i gemelli. 404 se assente / cross-tenant.
     * @endpoint get /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/pratiche-esercente/{id_pratica}/pdf-originale/download
* @param requestParameters
     */
    downloadPdfOriginalePraticaEsercenteBackoffice(requestParameters: DownloadPdfOriginalePraticaEsercenteBackofficeRequestParams, extraHttpRequestParams?: any): Observable<string>;

    /**
     * Export tabellare (dati, non file) delle domande esercente del bando.
     * Body: Page&lt;PraticaEsercenteDetailDTO&gt; (riga form-shaped: anagrafica-impresa frozen + form_data custom espanso, la stessa forma del detail) per il consumo dell\&#39;export Excel client-side del FE. Capability CONSULTAZIONE (lettura). Filtro riusa il Filter backoffice (stato/ragione_sociale/partita_iva/codice_pratica); default ?stato assente &#x3D; TUTTE le domande del bando. Il campo azioni_operatore_disponibili è omesso (variante self-service del mapper). Dichiarato PRIMA del detail /{id_pratica} così \&#39;export-tabular\&#39; non è id.
     * @endpoint get /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/pratiche-esercente/export-tabular
* @param requestParameters
     */
    exportTabularPraticheEsercenteBackoffice(requestParameters: ExportTabularPraticheEsercenteBackofficeRequestParams, extraHttpRequestParams?: any): Observable<PagedModelPraticaEsercenteDetailDTO>;

    /**
     * Export ZIP degli allegati delle domande esercente del bando.
     * Stream application/zip: 1 sub-folder {codice_pratica}/ per domanda con gli file prodotti dall\&#39;esercente (origine&#x3D;ESERCENTE: allegati del modulo e convenzione firmata) persistiti as-is + un _stato.txt. Il PDF originale e i documenti caricati dall\&#39;operatore hanno endpoint dedicati e restano fuori. Capability CONSULTAZIONE (lettura). Filtro stato override-able via ?stato (multi-select raw); default &#x3D; TUTTE le domande. Streaming memory-bound; errori S3 mid-stream best-effort. Dichiarato PRIMA del detail /{id_pratica}.
     * @endpoint get /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/pratiche-esercente/export-zip
* @param requestParameters
     */
    exportZipPraticheEsercenteBackoffice(requestParameters: ExportZipPraticheEsercenteBackofficeRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Dettaglio di una domanda esercente.
     * Cross-tenant (domanda↔bando di comune diverso) → 404 privacy-preserving.
     * @endpoint get /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/pratiche-esercente/{id_pratica}
* @param requestParameters
     */
    getPraticaEsercenteBackoffice(requestParameters: GetPraticaEsercenteBackofficeRequestParams, extraHttpRequestParams?: any): Observable<PraticaEsercenteDetailDTO>;

    /**
     * Timeline audit di una domanda esercente (paginata + filtrata).
     * Page ordinata per event_timestamp DESC. Filtri opzionali: event_type, actor_type, from, to. Range from&gt;to → 422. checkTipoPratica CONSULTAZIONE. Gli eventi COMUNICAZIONE_INVIATA/FALLITA espongono canale/esito (stato_da/stato_a null, no PII).
     * @endpoint get /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/pratiche-esercente/{id_pratica}/eventi
* @param requestParameters
     */
    listEventiPraticaEsercenteBackoffice(requestParameters: ListEventiPraticaEsercenteBackofficeRequestParams, extraHttpRequestParams?: any): Observable<PagedModelPraticaEsercenteEventoDTO>;

    /**
     * Negozi del titolare non ancora collegati alla domanda.
     * Elenco (non paginato, ordinato per nome) dei punti vendita del profilo della domanda che si possono ancora aggiungere. checkTipoPratica GESTIONE (e\&#39; il passo che precede la scrittura); 404 cross-tenant.
     * @endpoint get /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/pratiche-esercente/{id_pratica}/negozi-disponibili
* @param requestParameters
     */
    listNegoziDisponibiliPraticaEsercenteBackoffice(requestParameters: ListNegoziDisponibiliPraticaEsercenteBackofficeRequestParams, extraHttpRequestParams?: any): Observable<Array<NegozioDTO>>;

    /**
     * Elenca le note di lavorazione della domanda esercente.
     * Capability CONSULTAZIONE. Page ordinata per created_at DESC. Esclude le note cancellate logicamente (visibili solo a SUPERADMIN).
     * @endpoint get /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/pratiche-esercente/{id_pratica}/note
* @param requestParameters
     */
    listNotePraticaEsercente(requestParameters: ListNotePraticaEsercenteRequestParams, extraHttpRequestParams?: any): Observable<PagedModelPraticaEsercenteNotaDTO>;

    /**
     * Elenca le domande esercente del bando.
     * Page paginata + filtri opzionali (stato, ragione_sociale, partita_iva, codice_pratica) via query param. Scope per-comune (checkTipoPratica CONSULTAZIONE) → 403 fuori scope.
     * @endpoint get /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/pratiche-esercente
* @param requestParameters
     */
    listPraticheEsercenteBackoffice(requestParameters: ListPraticheEsercenteBackofficeRequestParams, extraHttpRequestParams?: any): Observable<PagedModelPraticaEsercenteSummaryDTO>;

    /**
     * Rigenera on-demand il PDF originale della domanda esercente coi dati live.
     * Upsert in-place sul PDF_PRATICA_ORIGINALE. Capability GESTIONE (mutazione). Gate SEMPLIFICATO (no PraticaEditGate/G1/G2 nel dominio esercente): R1 cross-tipo (404), R2 @Version (409). Nessun trigger auto post-commit. Response: 200 + {version} (invariata: il render non bumpa @Version). Rendering fallito → errore, NON 200 con rigenerazione non avvenuta.
     * @endpoint post /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/pratiche-esercente/{id_pratica}/rigenera-pdf
* @param requestParameters
     */
    rigeneraPdfPraticaEsercenteBackoffice(requestParameters: RigeneraPdfPraticaEsercenteBackofficeRequestParams, extraHttpRequestParams?: any): Observable<PraticaEsercentePdfRigeneraDTO>;

    /**
     * Sostituisce il documento da firmare di una domanda (solo modalita\&#39; DOMANDA).
     * Multipart: campo \&#39;version\&#39; + part \&#39;convenzione_da_firmare\&#39; (PDF, max 10 MB). Ammesso da IN_ATTESA_CONVENZIONE, IN_ATTESA_VALIDAZIONE e CONVENZIONE_RIFIUTATA: da validazione la domanda torna in attesa di convenzione e all\&#39;esercente riparte l\&#39;email. checkTipoPratica GESTIONE; 404 cross-tenant; 409 version stale; 422 modalita\&#39;/stato/PDF non validi.
     * @endpoint put /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/pratiche-esercente/{id_pratica}/convenzione-da-firmare
* @param requestParameters
     */
    sostituisciConvenzioneDaFirmareEsercenteBackoffice(requestParameters: SostituisciConvenzioneDaFirmareEsercenteBackofficeRequestParams, extraHttpRequestParams?: any): Observable<PraticaEsercenteDetailDTO>;

}
